import { Component, Injector, Input, OnInit } from '@angular/core';
import { ISlideMenu } from './slide-menu.interface';
import { BaseNewComponents } from '../../base-new-components';

@Component({
  selector: 'app-slide-menu',
  templateUrl: './slide-menu.component.html',
  styleUrls: ['./slide-menu.component.sass']
})
export class SlideMenuComponent extends BaseNewComponents implements OnInit {

  @Input() public item: ISlideMenu;
  constructor(protected injector: Injector) {
    super(injector)
  }

  ngOnInit() {
  }

}
